import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qw_wel.png'


const _withScopeId = n => (_pushScopeId("data-v-20151cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qwMessage" }
const _hoisted_2 = {
  key: 0,
  class: "sc_div"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subs" }, "仅支持png，jpg，jpeg格式，仅支持上传一张", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("清空并保存")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wel_img"
}, null, -1))

import { ref, onMounted, getCurrentInstance } from 'vue'
  import { ElMessage, ElMessageBox } from 'element-plus';
  import pageTitle from '@/components/pageTitle.vue';
  import { getConfigDetail,editConfig,delImage } from '@/axios/smartMarket';

  type inf = {
    content: string,
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'qwMessage',
  setup(__props) {

  let qwInfo = <inf|{}>ref({})
  let zxURL = ref('');
  let { proxy } = getCurrentInstance() as any;
  let isEdit = ref(false);
  // let htp = ref(proxy?.$uploadOP);
  let times = ref(new Date().getTime());

  onMounted(()=>{
    getConfigDetails();

    // if(location.origin.indexOf('mrt') > -1){
    //   htp.value = location.origin
    // }
  })

  function getConfigDetails(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getConfigDetail({
      premises_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].premises_id
    }).then((data:any) => {
      qwInfo.value = data;
      zxURL.value = data.image;
    }).catch((err:any) => {
      console.log(err)
    })
  }

  //编辑
  function edits(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    let info = {
      premises_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].premises_id,
      content: qwInfo.value.content,
      image: zxURL.value || ''
    }
    editConfig(info).then((data:any) => {
      ElMessage('编辑成功')
      isEdit.value = false;
      getConfigDetails();
    }).catch((err:any) => {
      console.log(err)
    })
    if(!zxURL.value){
      delImage({
        premises_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].premises_id,
      }).then((data:any) => {
        
      }).catch((err:any) => {
        console.log(err)
      })
    }
  }

  //清空并保存
  function clearsInfo(){
    ElMessageBox.confirm('是否清空并保存').then(() => {
      qwInfo.value.content = '';
      zxURL.value = '';
      edits();
    }).catch(() => {
      
    })
    
  }

  //图片删除
  function delImg(){
    if(!isEdit.value) return
    zxURL.value = '';
  }
  //图片上传
  function beforeAvatarUpload(val:any){
    console.log(val)
    if(val.type.includes('png') || val.type.includes('jpg') || val.type.includes('jpeg')){
      let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('premises_id',aci.company_list[sessionStorage.getItem('checkCompany') || 0].premises_id);
      let urls = `${proxy?.$uploadOP}/admin/work/uploadMedia`;
      if(location.origin.indexOf('mrt') > -1){
        urls = `${location.origin}/admin/work/uploadMedia`;
      }
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.setRequestHeader('authorization', aci.authorization);
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          if(infos.return_code == 200){
            zxURL.value = infos.data.url;
            times.value = new Date().getTime();
          }
          else{
            ElMessage(infos.return_msg)
          }
        }
      }
      return false;
    }
    else{
      ElMessage('请选择png格式图片')
    }
    return false;
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(pageTitle, { title: "加好友欢迎语" }),
    _createVNode(_component_el_form, {
      model: _unref(qwInfo),
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "文案：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(qwInfo).content,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(qwInfo).content) = $event)),
              type: "textarea",
              class: "tear",
              autosize: "",
              maxlength: "100",
              readonly: !_unref(isEdit)
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "图片：" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_unref(zxURL))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_icon, {
                      class: "el-icon-circle-close",
                      onClick: delImg
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CircleClose)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("img", {
                      src: _unref(zxURL) + '?' + _unref(times),
                      class: "upImg"
                    }, null, 8, _hoisted_3)
                  ]))
                : (_openBlock(), _createBlock(_component_el_upload, {
                    key: 1,
                    "show-file-list": false,
                    class: _normalizeClass(['avatar-uploader',!_unref(isEdit)?'dis_ava':'']),
                    action: "",
                    "before-upload": beforeAvatarUpload,
                    disabled: !_unref(isEdit)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon-plus avatar-uploader-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"])),
              _hoisted_4
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            (!_unref(isEdit))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(isEdit) //@ts-ignore
 ? isEdit.value = true : isEdit=true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: edits
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: clearsInfo
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _hoisted_8
  ]))
}
}

})